import { render } from "./EditPRsModal.vue?vue&type=template&id=186fa8ed"
import script from "./EditPRsModal.vue?vue&type=script&lang=js"
export * from "./EditPRsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__